<template lang='pug'>
	#user-list
		
		// TABLA
		r-table(
			loading-text='Cargando usuarios...'
			no-data-text='Sin usuarios.'
			ref='table'
			v-bind='tableProps'
			@detail='submitUpdate'
			@remove='submitDelete'
		)
			template( slot='actions' slot-scope='props' )
				r-btn-action(
					color='success'
					tooltip='Activar'
					v-if='props.item.flag_deactivated'
					@click='submitActivate(props)'
				)
					v-icon check_circle
				r-btn-action(
					color='error'
					tooltip='Desactivar'
					v-if='props.item.flag_activated'
					@click='submitDeactivate(props)'
				)
					v-icon cancel
				r-btn-action(
					color='grey darken-4'
					tooltip='Contraseña'
					@click='submitPassword(props)'
				)
					v-icon lock

		// DIALOGO
		//v-dialog( 
			persistent
			:width='1080' 
			v-model='dialog' 
			)
			r-form.white(
				ref='form'
				title='subir usuarios'
				v-bind='formProps'
				v-model='upload'
				@submit='submitUpload'
				)
				template( slot='footer-actions' )
					v-btn( 
						block 
						class='ml-2'
						color='success' 
						@click='submitDownload' 
					) descargar planilla &nbsp;
</template>

<script>
	//
	import axios from 'axios'
	import { mapActions, mapState } from 'vuex'
	//
	import { RBtnAction, RForm, RTable } from '../../../components/reusable_components/next'
	import UserModel from '../../../models/General/GUser'
	import Translator from '../../../services/translator'
	//
	import GUserFields from './GUserFields'
	import GUserFilters from './GUserFilters'
	import GUserHeaders from './GUserHeaders'
	//
	export default {
	    name: 'user-list',
	    components: {
	        RBtnAction,
	        RForm,
	        RTable,
	    },
	    computed: {

	        /**
	         * @description
	         * { function_description }
	         *
	         * @return     {Object}  { description_of_the_return_value }
	         */
	        formProps() {
	            return {
	                fields: GUserFields(),
	            }
	        },

	        /**
	         *
	         */
	        tableProps () {
	            return {
	                service: UserModel,
	                filters: GUserFilters,
	                headers: GUserHeaders,
	                paramFilter: {
	                	ignore_workstation: 'true',
	                },
	            }
	        },
	    },
	    data () {
	        return {
	            dialog: false,
	            selected: null,
	            upload: {},
	        }
	    },
	    methods: {

	        //
	        ...mapActions( 'MenuesModule', {
	            setItemsTopBar: 'setItemsTopBar',
	        }),

	        /**
	         * @description
	         * { function_description }
	         *
	         * @param      {Function}  error   The error
	         */
	        error(error) {
	            this.$toast.error(Translator(UserModel, error.response.data))
	        },

	        /**
	         * @description
	         * Refresh table
	         */
	        refresh() {
	            this.$refs.table.refresh()
	        },

	        /**
	         * @description
	         * Show user activate confirm toast
	         *
	         * @param	{Object}  Table item scope props
	         */
	        submitActivate ( event ) {
	            this.selected = event.item
	            this.$toast.confirm('¿Confirma la activacion del usuario seleccionado?', this.$toaster(this, this.toActivate))
	        },	        

	        /**
	         * @description
	         * Go to user create
	         *
	         * @param	{Object}  Table item scope props
	         */
	        submitCreate () {
	            this.$router.push({ name: 'user-create' })
	        },	        	        

	        /**
	         * @description
	         * Show user deactivate confirm toast
	         *
	         * @param	{Object}  Table item scope props
	         */
	        submitDeactivate(event) {
	            this.selected = event.item
	            this.$toast.confirm('¿Confirma la desactivacion del usuario seleccionado?', this.$toaster(this, this.toDeactivate))
	        },	        	        	        

	        /**
	         * @description
	         * Show user delete confirm toast
	         *
	         * @param	{Object}  Table item scope props
	         */
	        submitDelete(event){
	            this.selected = event.item
	            this.$toast.confirm( '¿Confirma la eliminación del usuario seleccionado?', this.$toaster(this, this.toDelete))
	        },

	        /**
	         * @description
	         * Go to user update password
	         *
	         * @param	{Object}  Table item scope props
	         */
	        submitPassword(event) {
	            this.$router.push({ 
	            	name: 'user-update-password', 
	            	params: { 
	            		id: event.item.id 
	            	} 
	            })
	        },
	        
	        /**
	         * @description
	         * Go to user update
	         *
	         * @param	{Object}  Table item scope props
	         */
	        submitUpdate(event) {
	            this.$router.push({ 
	            	name: 'user-update', 
	            	params: { 
	            		id: event.item.id 
	            	} 
	            })
	        },

	        /**
	         * @description
	         * { function_description }
	         */
	        successActivate() {
	            this.$toast.success('Usuario activado exitosamente.')
	        },

	        /**
	         * @description
	         * { function_description }
	         */
	        successDeactivate () {
	            this.$toast.success('Usuario desactivado exitosamente.')
	        },

	        /**
	         * @description
	         * { function_description }
	         */
	        successDelete () {
	            this.$toast.success('Usuario eliminado exitosamente.')
	        },

	        /**
	         * @description
	         * Returns an activate representation of the object.
	         */
	        toActivate() {
	            this.selected
	                .activate()
	                .sync()
	                .then(this.successActivate)
	            	.then(this.refresh)
	                .catch(this.error)
	        },

	        /**
	         * @description
	         * Returns a deactivate representation of the object.
	         */
	        toDeactivate() {
	            this.selected
	                .deactivate()
	                .sync()
	                .then(this.successDeactivate)
	            	.then(this.refresh)
	                .catch(this.error)
	        },

	        /**
	         * @description
	         * Returns a delete representation of the object.
	         */
	        toDelete () {
	            this.selected
	            	.delete()
	            	.then(this.successDelete)
	            	.then(this.refresh)
	            	.catch(this.error)
	        },

	        /**
	         * { function_description }
	         *
	         * @param      {boolean}  [value=false]  The value
	         * @return     {<type>}   { description_of_the_return_value }
	         */
	        toWait(value = false) {
	            return this.$refs.form.setWait(value)
	        },
	    },
	    beforeMount () {
	        this.setTitle('Usuarios')
	        this.setItemsTopBar([            {
	                action: this.submitCreate,
	                color: 'accent',
	                icon: 'add_circle',
	                text: 'crear usuario',
	                tip: 'Crear nuevo usuario',
	            },
	        ])
	    },
	}
</script>